import React, { useEffect, useState } from 'react';
import { Modal } from 'reactstrap'
import HighlightModal from './HighlightModal';
import VideoModal from './VideoModal';
import ContentTypeEnum from '../../helpers/enums/contentType'

function ContentModal(props) {
  const [styleProps, setStyleProps] = useState({ size: "lg" })
  return <Modal isOpen={props.isOpen} toggle={props.toggle} {...styleProps}>
    {props.content.type === ContentTypeEnum.YOUTUBE && <VideoModal toggle={props.toggle} content={props.content} />}
    {props.content.type === ContentTypeEnum.HTML && <HighlightModal toggle={props.toggle} content={props.content} />}
  </Modal>
}

export default ContentModal;